import { jsx as l, jsxs as i } from "react/jsx-runtime";
import "react";
var f = (t) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ l("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ l("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1660 -484)",
      fill: "white"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 2.5H0V5H20V2.5Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 7.5H0V10H20V7.5Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 12.5H0V15H20V12.5Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ l("path", {
      d: "M20 17.5H0V20H20V17.5Z",
      fill: "#D80027"
    }),
    /* @__PURE__ */ l("path", {
      d: "M10 0H0V10H10V0Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ l("path", {
      d: "M5.58453 6.90947C4.52996 6.90947 3.67504 6.05455 3.67504 4.99998C3.67504 3.94541 4.52996 3.09049 5.58453 3.09049C5.91336 3.09049 6.2227 3.17361 6.49285 3.32002C6.0691 2.90568 5.48965 2.6499 4.85016 2.6499C3.55223 2.6499 2.5 3.70205 2.5 4.99998C2.5 6.29791 3.55223 7.35006 4.85008 7.35006C5.48957 7.35006 6.06906 7.09428 6.49277 6.67994C6.2227 6.82627 5.91332 6.90947 5.58453 6.90947Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M6.12164 3.6571L6.46063 4.36605L7.22625 4.18914L6.88336 4.89613L7.49906 5.38437L6.7325 5.55718L6.73469 6.34296L6.12164 5.85136L5.50859 6.34296L5.5107 5.55718L4.74414 5.38437L5.35984 4.89613L5.01699 4.18914L5.78258 4.36605L6.12164 3.6571Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  f as default
};
